import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-sea-800 text-white py-8 px-6" data-testid="footer">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <div className="flex items-center gap-2 justify-center md:justify-start mb-2">
              <div className="w-6 h-6 bg-gradient-to-br from-olive-500 to-olive-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xs">O</span>
              </div>
              <span className="font-semibold">OspitAI</span>
            </div>
            <p className="text-sea-300 text-sm">© 2026 OspitAI. All rights reserved.</p>
          </div>
          
          <div className="flex gap-6">
            <Link 
              to="/terms" 
              className="text-sea-300 hover:text-white text-sm transition-colors"
              data-testid="footer-terms-link"
            >
              Terms & Conditions
            </Link>
            <Link 
              to="/privacy" 
              className="text-sea-300 hover:text-white text-sm transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
        
        <div className="mt-6 pt-6 border-t border-sea-700 text-center">
          <p className="text-sea-400 text-xs">
            Unauthorized reproduction or use of this platform is prohibited.
          </p>
        </div>
      </div>
    </footer>
  );
};
